import { defineStore } from "pinia";

export const useEcosystemPartnerStore = defineStore({
  id: "ecosystemPartner",
  state: () => ({
    hasEcosystemAccess: false,
    loadingEcosystemAccess: false,
    errorEcosystemAccess: false,

    learnextData: {},
    loadingLearnextPage: false,
    errorLearnextPage: false,

    qubisaUrl: "",
    loadingQubisaPage: false,

    qubisaCourseList: [],
    loadingGetQubisaCourses: false,

    courses: {
      list: [],
      totalElements: 0,
      totalPages: 0,
      size: 12,
    },
    loadingGetAllCourse: false,
    errorGetAllCourse: false,

    myCourses: {
      list: [],
      totalElements: 0,
      totalPages: 0,
      size: 12,
    },
    loadingGetMyCourse: false,
    errorGetMyCourse: false,

    courseDetail: {},
    loadingGetCourseDetail: {},
    errorGetCourseDetail: {},

    loadingViewCertificate: {},
    loadingDownloadCertificate: {},
    pathCertificate: "",
    viewCertificateDialog: false,

    partnerList: [],
    errorGetAllPartners: false,
    loadingGetAllPartners: false,

    loadingQubisaSlugPage: {},
  }),
  actions: {
    async checkEcosystemAccess() {
      try {
        this.loadingEcosystemAccess = true;
        const event = useRequestEvent();
        const response = await fetchBelajarWajib(
          event,
          "/trans/api/enroll/access-ekosistem",
          "GET",
        );
        useEcosystemPartnerStore().$patch((state) => {
          state.hasEcosystemAccess = response?.hasAccess;
        });
        this.errorEcosystemAccess = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          // useUserStore().$patch({
          //   snackStatus: "error",
          //   snackbar: true,
          //   messageSnack:
          //     error?.response?._data?.message || "Terjadi kesalahan.",
          // });
          this.errorEcosystemAccess = true;
        }
      } finally {
        this.loadingEcosystemAccess = false;
      }
    },
    async getLearnextPage(type = "") {
      this.loadingLearnextPage = true;
      try {
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          `/trans/api/enroll/learnext-sso-url${
            type ? `?learnextContentType=${type}` : ""
          }`,
          "GET",
        );
        useEcosystemPartnerStore().$patch((state) => {
          state.learnextData = response || {};
        });
        this.errorLearnextPage = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorLearnextPage = true;
        }
      } finally {
        this.loadingLearnextPage = false;
      }
    },
    async getQubisaPage() {
      this.loadingQubisaPage = true;
      try {
        if (this.qubisaCourseList.length === 0) {
          this.$patch((state) => {
            state.qubisaUrl = [];
          });
          return;
        }
        const responses = [];
        for (let i = 0; i < this.qubisaCourseList.length; i++) {
          const course = this.qubisaCourseList[i];
          const response = await fetchBelajarWajib(
            useRequestEvent(),
            `/trans/api/ekosistem-partner/qubisa/sso${
              !course?.contentURL
                ? ""
                : `?callbackUrl=${encodeURIComponent(course.contentURL)}`
            }`,
            "POST",
          );
          if (response?.redirectUrl) {
            responses.push({
              id: i,
              url: response.redirectUrl,
            });
          }
        }
        this.$patch((state) => {
          state.qubisaUrl = responses;
        });
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || "Terjadi kesalahan.",
          });
        }
      } finally {
        this.loadingQubisaPage = false;
      }
    },
    async getQubisaCourses() {
      this.loadingGetQubisaCourses = true;
      try {
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          "/trans/api/ekosistem-partner/qubisa/courses",
          "GET",
        );
        useEcosystemPartnerStore().$patch((state) => {
          state.qubisaCourseList = response || [];
        });
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || "Terjadi kesalahan.",
          });
        }
      } finally {
        this.loadingGetQubisaCourses = false;
      }
    },
    async getQubisaSsoUrl() {
      try {
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          `/trans/api/ekosistem-partner/qubisa/sso`,
          "POST",
        );
        useEcosystemPartnerStore().$patch((state) => {
          state.qubisaUrl = response?.redirectUrl || "";
        });
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || "Gagal mendapatkan link SSO.",
          });
        }
      }
    },
    async getQubisaSlugSsoUrl(contentURL) {
      this.loadingQubisaSlugPage[contentURL] = true;
      try {
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          `/trans/api/ekosistem-partner/qubisa/sso?callbackUrl=${contentURL}`,
          "POST",
        );
        window.open(
          response?.redirectUrl || "",
          "_blank",
          "noopener, noreferrer",
        );
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || "Terjadi kesalahan.",
          });
        }
      } finally {
        this.loadingQubisaSlugPage[contentURL] = false;
      }
    },
    async getAllCourse(search, page, size, tahun, sortBy, partnerGuids) {
      try {
        this.loadingGetAllCourse = true;
        const event = useRequestEvent();
        const response = await fetchBelajarWajib(
          event,
          "/learning/api/user/course",
          "POST",
          {
            search: search,
            page: page,
            size: size,
            tahun: tahun,
            sortBy: sortBy,
            partnerGuids: partnerGuids,
          },
        );
        useEcosystemPartnerStore().$patch((state) => {
          state.courses = {
            list: response?.content || [],
            totalElements: response?.totalElements || 0,
            totalPages: response?.totalPages || 0,
            size: response?.size || 10,
          };
        });
        this.errorGetAllCourse = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetAllCourse = true;
        }
      } finally {
        this.loadingGetAllCourse = false;
      }
    },
    async getMyCourse(search, page, size, status, tahun, sortBy, partnerGuids) {
      try {
        this.loadingGetMyCourse = true;
        const event = useRequestEvent();
        const response = await fetchBelajarWajib(
          event,
          "/trans/api/user/ecosystem/enroll/me",
          "POST",
          {
            search: search,
            page: page,
            size: size,
            status: status,
            tahun: tahun,
            sortBy: sortBy,
            partnerGuids: partnerGuids,
          },
        );
        useEcosystemPartnerStore().$patch((state) => {
          state.myCourses = {
            list: response?.content || [],
            totalElements: response?.totalElements || 0,
            totalPages: response?.totalPages || 0,
            size: response?.size || 10,
          };
        });
        this.errorGetMyCourse = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetMyCourse = true;
        }
      } finally {
        this.loadingGetMyCourse = false;
      }
    },
    async getCourseDetail(course) {
      try {
        this.loadingGetCourseDetail[course.courseGuid] = true;
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          `/learning/api/user/course/${course.courseGuid}`,
          "POST",
          {
            referral: "lan",
          },
        );
        useEcosystemPartnerStore().$patch((state) => {
          state.courseDetail = response || {};
        });
        this.errorGetCourseDetail[course.courseGuid] = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetCourseDetail[course.courseGuid] = true;
        }
      } finally {
        this.loadingGetCourseDetail[course.courseGuid] = false;
      }
    },
    async actionCertificate(type, enrollmentGuid) {
      if (type === "Lihat") {
        this.loadingViewCertificate[enrollmentGuid] = true;
      } else {
        this.loadingDownloadCertificate[enrollmentGuid] = true;
      }
      try {
        const res = await fetchBelajarWajib(
          useRequestEvent(),
          `/trans/api/user/ecosystem/enroll/${
            type === "Lihat" ? "view" : "download"
          }/path-sertifikat?enrollmentGuid=${enrollmentGuid}`,
          "GET",
        );
        if (res) {
          const blob = new Blob([res], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          if (type === "Unduh") {
            const link = document.createElement("a");
            link.href = url;
            link.download = `Sertifikat_${enrollmentGuid}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            useUserStore().$patch({
              snackStatus: "green",
              snackbar: true,
              messageSnack: "Sukses mengunduh sertifikat.",
            });
          } else {
            useEcosystemPartnerStore().$patch({
              pathCertificate: url,
              viewCertificateDialog: true,
            });
          }
        }
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || `Gagal ${type} sertifikat.`,
          });
        }
      } finally {
        if (type === "Lihat") {
          this.loadingViewCertificate[enrollmentGuid] = false;
        } else {
          this.loadingDownloadCertificate[enrollmentGuid] = false;
        }
      }
    },
    async getAllPartners() {
      try {
        this.loadingGetAllPartners = true;
        const event = useRequestEvent();
        const response = await fetchBelajarWajib(
          event,
          "/learning/api/belajar-mandiri/partners/all",
          "GET",
        );
        useEcosystemPartnerStore().$patch((state) => {
          state.partnerList = response || [];
        });
        this.errorGetAllPartners = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetAllPartners = true;
        }
      } finally {
        this.loadingGetAllPartners = false;
      }
    },
  },
});
